export const TIME_ZONE_ABBREVIATIONS: { [key: string]: string } = {
  'Africa/Casablanca': 'WEST',
  'Africa/El_Aaiun': 'WEST',
  'America/Araguaina': 'BRT',
  'America/Argentina/Buenos_Aires': 'ART',
  'America/Argentina/Catamarca': 'ART',
  'America/Argentina/Cordoba': 'ART',
  'America/Argentina/Jujuy': 'ART',
  'America/Argentina/La_Rioja': 'ART',
  'America/Argentina/Mendoza': 'ART',
  'America/Argentina/Rio_Gallegos': 'ART',
  'America/Argentina/Salta': 'ART',
  'America/Argentina/San_Juan': 'ART',
  'America/Argentina/San_Luis': 'ART',
  'America/Argentina/Tucuman': 'ART',
  'America/Argentina/Ushuaia': 'ART',
  'America/Asuncion': 'PYST',
  'America/Bahia': 'BRT',
  'America/Belem': 'BRT',
  'America/Boa_Vista': 'AMT',
  'America/Bogota': 'COT',
  'America/Campo_Grande': 'AMT',
  'America/Caracas': 'VET',
  'America/Cayenne': 'GFT',
  'America/Cuiaba': 'AMT',
  'America/Eirunepe': 'ACT',
  'America/Fortaleza': 'BRT',
  'America/Guayaquil': 'ECT',
  'America/Guyana': 'GYT',
  'America/La_Paz': 'BOT',
  'America/Lima': 'PET',
  'America/Maceio': 'BRT',
  'America/Manaus': 'AMT',
  'America/Miquelon': 'PMST',
  'America/Montevideo': 'UYT',
  'America/Noronha': 'FNT',
  'America/Nuuk': 'WGT',
  'America/Paramaribo': 'SRT',
  'America/Porto_Velho': 'AMT',
  'America/Punta_Arenas': 'CLST',
  'America/Recife': 'BRT',
  'America/Rio_Branco': 'ACT',
  'America/Santarem': 'BRT',
  'America/Santiago': 'CLST',
  'America/Sao_Paulo': 'BRT',
  'America/Scoresbysund': 'WGT',
  'Antarctica/Casey': 'CAST',
  'Antarctica/Davis': 'DAVT',
  'Antarctica/DumontDUrville': 'DDUT',
  'Antarctica/Mawson': 'MAWT',
  'Antarctica/Palmer': 'CLST',
  'Antarctica/Rothera': 'ART',
  'Antarctica/Syowa': 'SYOT',
  'Antarctica/Troll': 'GMT',
  'Antarctica/Vostok': 'VOST',
  'Asia/Aden': 'AST',
  'Asia/Almaty': 'ALMT',
  'Asia/Amman': 'EEST',
  'Asia/Anadyr': 'ANAT',
  'Asia/Aqtau': 'AQTT',
  'Asia/Aqtobe': 'AQTT',
  'Asia/Ashgabat': 'TMT',
  'Asia/Atyrau': 'AQTT',
  'Asia/Baghdad': 'AST',
  'Asia/Bahrain': 'AST',
  'Asia/Baku': 'AZT',
  'Asia/Bangkok': 'ICT',
  //'Asia/Barnaul': 'MSK+4',
  'Asia/Bishkek': 'KGT',
  'Asia/Brunei': 'BNT',
  'Asia/Chita': 'YAKT',
  //'Asia/Choibalsan': '+08',
  'Asia/Colombo': 'IST',
  //'Asia/Dacca': '+06',
  'Asia/Damascus': 'EEST',
  'Asia/Dhaka': 'BST',
  'Asia/Dili': 'TLT',
  'Asia/Dubai': 'GST',
  'Asia/Dushanbe': 'TJT',
  'Asia/Ho_Chi_Minh': 'ICT',
  'Asia/Hovd': 'HOVT',
  'Asia/Irkutsk': 'IRKT',
  //'Asia/Istanbul': '+03',
  'Asia/Kabul': 'AFT',
  'Asia/Kamchatka': 'PETT',
  //'Asia/Kashgar': '+06',
  'Asia/Kathmandu': 'NPT',
  // 'Asia/Katmandu': '+0545',
  'Asia/Khandyga': 'YAKT',
  'Asia/Krasnoyarsk': 'KRAT',
  'Asia/Kuala_Lumpur': 'MYT',
  'Asia/Kuching': 'MYT',
  'Asia/Kuwait': 'AST',
  'Asia/Magadan': 'MAGT',
  'Asia/Muscat': 'GST',
  'Asia/Novokuznetsk': 'KRAT',
  'Asia/Novosibirsk': 'NOVT',
  'Asia/Omsk': 'OMST',
  'Asia/Oral': 'ORAT',
  'Asia/Phnom_Penh': 'ICT',
  'Asia/Qatar': 'AST',
  'Asia/Qostanay': 'ALMT',
  //'Asia/Qyzylorda': 'MSK+2',
  //'Asia/Rangoon': '+0630',
  'Asia/Riyadh': 'AST',
  //'Asia/Saigon': '+07',
  'Asia/Sakhalin': 'SAKT',
  'Asia/Samarkand': 'UZT',
  'Asia/Singapore': 'SGT',
  'Asia/Srednekolymsk': 'SRET',
  'Asia/Tashkent': 'UZT',
  'Asia/Tbilisi': 'GET',
  'Asia/Tehran': 'IRST',
  //'Asia/Thimbu': '+06',
  'Asia/Thimphu': 'BTT',
  //'Asia/Tomsk': 'MSK+4',
  'Asia/Ulaanbaatar': 'ULAT',
  //'Asia/Ulan_Bator': '+08',
  'Asia/Urumqi': 'URUT',
  'Asia/Ust-Nera': 'VLAT',
  'Asia/Vientiane': 'ICT',
  'Asia/Vladivostok': 'VLAT',
  'Asia/Yakutsk': 'YAKT',
  'Asia/Yangon': 'MMT',
  'Asia/Yekaterinburg': 'YEKT',
  'Asia/Yerevan': 'AMT',
  'Atlantic/Azores': 'AZOT',
  'Atlantic/Cape_Verde': 'CVT',
  'Atlantic/South_Georgia': 'GST',
  'Atlantic/Stanley': 'FKT',
  'Australia/Eucla': 'ACWST',
  //'Australia/LHI': '+11',
  'Australia/Lord_Howe': 'LHDT',
  // 'Brazil/Acre': '-05',
  // 'Brazil/DeNoronha': '-02',
  //'Brazil/East': '-03',
  //'Brazil/West': '-04',
  //'Chile/Continental': '-03',
  //'Chile/EasterIsland': '-05',
  //'Europe/Astrakhan': 'MSK+1',
  'Europe/Istanbul': 'TRT',
  'Europe/Minsk': 'MSK',
  'Europe/Samara': 'SAMT',
  //'Europe/Saratov': 'MSK+1',
  //'Europe/Ulyanovsk': 'MSK+1',
  'Indian/Chagos': 'IOT',
  'Indian/Christmas': 'CXT',
  'Indian/Cocos': 'CCT',
  'Indian/Kerguelen': 'TFT',
  'Indian/Mahe': 'SCT',
  'Indian/Maldives': 'MVT',
  'Indian/Mauritius': 'MUT',
  'Indian/Reunion': 'RET',
  //'NZ-CHAT': '+1345',
  'Pacific/Apia': 'WST',
  'Pacific/Bougainville': 'BST',
  'Pacific/Chatham': 'CHADT',
  'Pacific/Chuuk': 'CHUT',
  'Pacific/Easter': 'EASST',
  'Pacific/Efate': 'VUT',
  //'Pacific/Enderbury': '+13',
  'Pacific/Fakaofo': 'TKT',
  'Pacific/Fiji': 'FJT',
  'Pacific/Funafuti': 'TVT',
  'Pacific/Galapagos': 'GALT',
  'Pacific/Gambier': 'GAMT',
  'Pacific/Guadalcanal': 'SBT',
  'Pacific/Kanton': 'PHOT',
  'Pacific/Kiritimati': 'LINT',
  'Pacific/Kosrae': 'KOST',
  //'Pacific/Majuro': '+12',
  'Pacific/Marquesas': 'MART',
  'Pacific/Nauru': 'NRT',
  'Pacific/Niue': 'NUT',
  'Pacific/Norfolk': 'NFDT',
  'Pacific/Noumea': 'NCT',
  //'Pacific/Palau': '+09',
  'Pacific/Pitcairn': 'PST',
  'Pacific/Pohnpei': 'PONT',
  //'Pacific/Ponape': '+11',
  'Pacific/Port_Moresby': 'PGT',
  'Pacific/Rarotonga': 'CKT',
  'Pacific/Tahiti': 'TAHT',
  'Pacific/Tarawa': 'GILT',
  'Pacific/Tongatapu': 'TOT',
  'Pacific/Wake': 'WAKT',
  'Pacific/Wallis': 'WFT',
};
